import React from 'react';
import styled from 'styled-components';
import { borderRadius, grid } from './constants';
import { ReactComponent as UserAvatarDefaut } from '@zendeskgarden/svg-icons/src/16/user-circle-stroke.svg';
import { Colors, ContainerProps, StepColors, StepColorsbackground } from '../types';
import { ReactComponent as ThumbsUpFill } from '@zendeskgarden/svg-icons/src/16/thumbs-up-fill.svg';
import { ReactComponent as ThumbsDownFill } from '@zendeskgarden/svg-icons/src/16/thumbs-down-fill.svg';
import { ReactComponent as ThumbsUpStroke } from '@zendeskgarden/svg-icons/src/16/thumbs-up-stroke.svg';
import { ReactComponent as ThumbsDownStroke } from '@zendeskgarden/svg-icons/src/16/thumbs-down-stroke.svg';
import { ReactComponent as AlertIcon } from '@zendeskgarden/svg-icons/src/16/alert-error-fill.svg';
import { connect } from 'react-redux';
import { Dispatch, AnyAction, bindActionCreators } from 'redux';
import { clickUpdateShortlistStatusIsReproved,
  clickUpdateShortlistStatusIsSelected } from '../../../../actions';
import FileStackService from '../../../../services/filestack.service';
import { t } from '../../../../translations/translation.service';

const getBackgroundColor = (colors: Colors) => {
  if (colors.soft === "#3498db" || colors.soft === "#2ecc71") {
    return '#ffffff';
  }

  return colors.soft;
};

const imageSize = 40;

const Container = styled.div<ContainerProps>`
  border-radius: ${borderRadius}px;
  background-color: ${(props) => getBackgroundColor(props.colors)};
  box-shadow: 2px 2px 5px #5b6982ff;
  box-sizing: border-box;
  padding: ${grid}px;
  min-height: ${imageSize}px;
  margin-bottom: ${grid}px;
  user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
  width: 200px;
  /* flexbox */
  display: flex;
`;

const Avatar = styled.img`
  width: ${imageSize}px;
  height: ${imageSize}px;
  border-radius: 50%;
  margin-right: ${grid}px;
  flex-shrink: 0;
  flex-grow: 0;
`;

const Content = styled.div`
  /* flex child */
  flex-grow: 1;
  flex-basis: 100%;
  /* flex parent */
  display: flex;
  flex-direction: column;
  width: inherit;
  & p {
    margin: 0 0 10px 0;
    font-weight: 500;
    text-align: center;
  }
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${grid}px;
  align-items: center;
  gap: 10px;
`;

const Curriculum = styled.small<ContainerProps>`
  color: white;
  flex-grow: 0;
  margin: 0 auto;
  background-color: ${(props) => props.colors.soft || 'gray'};
  width: 100%;
  font-weight: normal;
  padding: ${grid / 2}px;
  display: flex;
  justify-content: center;
`;

const BackgroundAvatar = styled.div<Colors>`
  width: 80%;
  border-radius: 8px;
  margin-right: ${grid}px;
  flex-shrink: 0;
  flex-grow: 0;
  background-color: ${(props) => StepColorsbackground[
    props.soft as keyof typeof StepColorsbackground
  ] || '#ccc'};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${grid}px;
`;

const CvLinkButton = styled.a`
  background-color: transparent;
  width: inherit;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  :hover {
    text-decoration: none;
    color: #ed961c;
  }
`;

const ThumbsButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 2px 22px 2px 22px;
  margin-left: 5px;
`;

const Thumbsup = styled.span<{ animate?: boolean }>`
  display: inline-flex;
  ${({ animate }) => animate && `
    svg {
      transform: translateY(-8px) scale(1.1);
      animation: thumbsUpAnim 0.6s cubic-bezier(0.6, 0, 0.2, 1);
    }
  `}
  @keyframes thumbsUpAnim {
    0% { transform: translateY(-10px) scale(1) rotate(-20deg); }
    30% { transform: translateY(-5px) scale(1.4) rotate(-30deg); }
    60% { transform: translateY(-2px) scale(1.05) rotate(-35deg); }
    100% { transform: translateY(0) scale(1) rotate(0deg); }
  }
`;

const Thumbsdown = styled.span<{ animate?: boolean }>`
  display: inline-flex;
  ${({ animate }) => animate && `
    svg {
      transform: translateY(8px) scale(1.1) rotate(-180deg);
      animation: thumbsDownAnim 0.6s cubic-bezier(0.6, 0, 0.2, 1);
    }
  `}

  @keyframes thumbsDownAnim {
    0% { transform: translateY(10px) scale(1) rotate(-20deg); }
    30% { transform: translateY(5px) scale(1.4) rotate(-30deg); }
    60% { transform: translateY(2px) scale(1.05) rotate(-35deg); }
    100% { transform: translateY(0) scale(1) rotate(0deg); }
  }
`;

class Candidate extends React.PureComponent<any, {
  policyAndSignature: string[];
  likeAnimateThumbsUp: boolean,
  likeAnimateThumbsDown: boolean,
  thumbImgTypeSelected: boolean,
  thumbImgTypeReproved: boolean,
  policyString: string,
  signatureString: string,
  policyAndSignatureImg: string,
  showBehavioralModal: boolean,
}> {
  state = {
    likeAnimateThumbsUp: false,
    likeAnimateThumbsDown: false,
    thumbImgTypeSelected: this.props.candidate.isSelected,
    thumbImgTypeReproved: this.props.candidate.isReproved,
    policyAndSignature: [],
    policyString: '',
    signatureString: '',
    policyAndSignatureImg: '',
    showBehavioralModal: false,
  };

  componentDidMount(): void {
    const attchUrl = !!this.props.candidate.attachmentUrl[0];
    if (attchUrl) {
      const attch = [{url: this.props.candidate.attachmentUrl[0]}];
      this.getFileStackPolicy(attch);
    }
    this.getFileStackPolicyToUserImg(this.props.candidate.userImageUrl);
  }

  async getFileStackPolicy(attachments: {url: string}[]): Promise<void> {
    try {
      const policy = await FileStackService.getFileStackSecreteCodeToUserSignup(attachments, true);
      this.setState({ policyAndSignature: policy.data });
    } catch (err: any) {
      console.log("Erro ao obter credenciais - ERROR: ", err);
    }
  }

  getNewFileStackUrl(url: string): boolean {
    const domain = url.split('/')[2];
    if (domain.includes('cdn.file')) {
      return true;
    }
    return false;
  }

  async getFileStackPolicyToUserImg(userImg: string): Promise<void> {
    try {
      if (
        userImg &&
        this.getNewFileStackUrl(userImg)
      ) {
        const policyUserImg = await FileStackService.getFileStackSecreteCodeToUserSignup(
          userImg, false
        );
        this.setState({ policyAndSignatureImg: policyUserImg.data });
      }
    } catch (err: any) {
      console.log("Erro ao obter credenciais - ERROR: ", err);
    }
  }

  setUrlAttachment(url: string, index: number): string {
    const { policyAndSignature } = this.state;
    if (url) {
      const splitedUrl = url.split('/');
      const newUrl = `https://${splitedUrl[2]}${policyAndSignature[index]}/${splitedUrl.at(-1)}`;
      return newUrl;
    }
    return '';
  }

  setUrlImg(url: string): string {
    const { policyAndSignatureImg } = this.state;
    const splitedUrl = url.split('/');
    const newUrl = `https://${splitedUrl[2]}${policyAndSignatureImg}/${splitedUrl.at(-1)}`;
    return newUrl;
  }

  handleLike = () => {
    this.setState(prevState => ({
      likeAnimateThumbsUp: true,
      thumbImgTypeSelected: !prevState.thumbImgTypeSelected,
      thumbImgTypeReproved: false,
    }));

    setTimeout(() => {
      this.setState({ likeAnimateThumbsUp: false });
    }, 300);

    this.props.clickUpdateShortlistStatusIsSelected({
      status: !this.state.thumbImgTypeSelected,
      id: this.props.candidate._id
    });
  };

  handleDislike = () => {
    this.setState(prevState => ({
      likeAnimateThumbsDown: true,
      thumbImgTypeReproved: !prevState.thumbImgTypeReproved,
      thumbImgTypeSelected: false,
    }));

    setTimeout(() => {
      this.setState({ likeAnimateThumbsDown: false });
    }, 300);

    this.props.clickUpdateShortlistStatusIsReproved({
      status: !this.state.thumbImgTypeReproved,
      id: this.props.candidate._id
    });
  };

  render() {
    const { candidate, isClone, index, colors } = this.props;
    return (
      <Container
        isClone={isClone}
        colors={{
          hard: StepColors[colors as keyof typeof StepColors],
          soft: StepColors[colors as keyof typeof StepColors]
        }}
        data-testid={candidate.id || 'N/A'}
        data-index={index}
        aria-label={candidate.name}
      >
        <BackgroundAvatar soft={colors}>
          {
            candidate.userImageUrl
              ? <Avatar
                  src={
                    candidate.userImageUrl &&
                    this.getNewFileStackUrl(candidate.userImageUrl)
                    ? this.setUrlImg(candidate.userImageUrl)
                    : candidate.userImageUrl
                  }
                  alt={candidate.name}
                />
              : <UserAvatarDefaut width={40} height={40} color='white'/>
          }
        </BackgroundAvatar>
        <Content>
          <p>{candidate.name}</p>
          <Footer>
            <Curriculum colors={{
              hard: StepColorsbackground[colors as keyof typeof StepColorsbackground],
              soft: StepColorsbackground[colors as keyof typeof StepColorsbackground]
            }}>
              {
                candidate.attachmentUrl.length > 0 && (
                  <CvLinkButton
                    href={candidate.attachmentUrl.length > 0
                      ? this.setUrlAttachment(candidate?.attachmentUrl[0], 0)
                      : '#'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("Currículo")}
                  </CvLinkButton>
                )
              }
              {
                candidate.attachmentUrl.length === 0 && (
                  <AlertIcon
                    color='red'
                    width={34}
                    height={21}
                  />
                )
              }
            </Curriculum>
            <div>
              <ThumbsButton>
                <Thumbsup
                  animate={this.state.likeAnimateThumbsUp}
                  onClick={() => {
                    this.handleLike();
                  }}
                >
                  {
                    this.state.thumbImgTypeSelected
                      ? <ThumbsUpFill color='#0fd05fff'/>
                      : <ThumbsUpStroke color='#0fd05fff'/>
                  }
                </Thumbsup>
              </ThumbsButton>
              <ThumbsButton>
                <Thumbsdown
                  animate={this.state.likeAnimateThumbsDown}
                  onClick={() => {
                    this.handleDislike();
                  }}
                >
                  {
                    this.state.thumbImgTypeReproved
                      ? <ThumbsDownFill color='#e74533'/>
                      : <ThumbsDownStroke color='#e74533'/>
                  }
                </Thumbsdown>
              </ThumbsButton>
            </div>
          </Footer>
        </Content>
      </Container>
    );
  }
}

const mapStateToProps = (store: {
  shortlistUpdateReducer: {
    shortlistStatusIsSelected: any,
    shortlistStatusIsReproved: any
  };
}) => ({
  shortlistStatusIsSelected: store.shortlistUpdateReducer.shortlistStatusIsSelected,
  shortlistStatusIsReproved: store.shortlistUpdateReducer.shortlistStatusIsReproved,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators(
  {
    clickUpdateShortlistStatusIsReproved,
    clickUpdateShortlistStatusIsSelected,
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(Candidate);